export const DEFAULT_LANG = 'en'
export const SUPPORTED_LANGS = ['en', 'fr', 'no', 'jk']

export function getLang(search) {
	const query = search ?? (typeof window !== 'undefined' ? window.location.search : '')
	const raw = new URLSearchParams(query).get('lang')
	if (!raw) return DEFAULT_LANG

	const lang = raw.trim().toLowerCase().split(/[-_]/)[0]
	return SUPPORTED_LANGS.includes(lang) ? lang : DEFAULT_LANG
}

export function translate(translations, fallback, lang) {
	const target = lang ?? getLang()
	if (target === DEFAULT_LANG) return fallback

	const translated = translations?.[target]
	return typeof translated === 'string' && translated.trim() ? translated : fallback
}

export function mapLabel(mapDetails, lang) {
	if (!mapDetails) return ''
	return translate(mapDetails.translations, mapDetails.label, lang)
}
